import React from 'react';
import UnderConstruction from '../components/UnderConstruction';

const Templates: React.FC = () => {
  return <UnderConstruction title="模板中心" />;
};

export default Templates; 